export const saveToStorage = (key: string, value: string) => {
    localStorage.setItem(key, value);
};

export const getFromStorage = (key: string) => {
    try {
        const item = localStorage.getItem(key);
        console.log('item', item);
        return item || null;
    } catch (error) {
        console.error('Error reading from storage:', error);
        return null;
    }
};

export const removeFromStorage = (key: string) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error('Error removing from storage:', error);
    }
};
